export default "__VITE_ASSET__DvrQV07J__"